// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  section {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .hide {
    display: none;
  }

  .no-flex {
    display: block;
  }

  #tcp-get-candid-image-container {
    max-width: 1056px;
    margin: 0 auto;
  }

  @media ${(props) => props.theme.mediaQuery.xlarge} {
    #tcp-get-candid-image-container {
      margin: 0 auto;
    }
  }
  .min-height-candid {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 420px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 357.5px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 376.5px;
    }
  }

  .get-candid-main-heading {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }

  .get-candid-heading-desc {
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};

    @media ${(props) => props.theme.mediaQuery.large} {
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
      margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
  }

  div.get-candid-button-container {
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    margin: 17px auto 32px;
  }

  .gellary-button-right {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 164px;
      margin-left: 7px;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 162px;
      margin-left: 6px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 210px;
      margin-left: 6px;
    }
  }

  .gallery-button-left {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 164px;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 162px;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: 210px;
      margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
  }

  &.brand-tcp .get-candid-main-heading {
    font-family: TofinoWide;
  }

  &.brand-tcp .get-candid-heading-desc {
    font-family: Nunito;
  }

  ${(props) =>
    props.isPDP
      ? `.get-candid-default-heading {
    margin-top: ${props.theme.spacing.ELEM_SPACING.MED};
    padding-top: ${props.theme.spacing.ELEM_SPACING.XXS};
  }
 `
      : ``}
  .skeleton-candid-default-heading {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .skeleton-candid-main-heading {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 43px;
      width: 350px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 27px;
      width: 270px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 27.5px;
      width: 209px;
    }
  }
  .skeleton-candid-heading-desc {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 27px;
      width: 600px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 19px;
      width: 400px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 38px;
      width: 90%;
    }
  }
  .tcp-skeleton-candid-image-container {
    margin-right: 30px;
    float: left;
    display: block;

    @media ${(props) => props.theme.mediaQuery.large} {
      height: 210px;
      width: 210px;
      &.item-5 {
        display: none;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      height: 188px;
      width: 162px;
      &.item-5 {
        margin-right: 0;
      }
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 188px;
      width: 164px;
    }
  }
  .skeleton-candid-col-item-container {
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: 2%;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      overflow: hidden;
      display: flex;
      justify-content: center;
      margin-left: 5%;
      margin-right: 4% !important;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      overflow: hidden;
    }
  }
  .skeleton-candid-item-container {
    display: flex;
    justify-content: center;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      width: 1000px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      display: block;
    }
  }
  .skeleton-button-candid {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 51px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      height: 42px;
    }
  }
`;
